import { dayjs } from "@outschool/time";

export const Topics = [
  "Drawing",
  "Gaming",
  "Dance",
  "Art",
  "Escape Rooms",
  "Singing",
  "Clubs",
  "Semester Courses",
  "Tutoring",
  "Test Prep",
  "Spanish",
  "Circle Time",
  "Creative Writing",
  "Valentine's Day",
  "St. Patrick's Day",
  "Women's History",
  "Spring Break",
  "Mother's Day",
  "Father's Day",
  "Halloween",
  "Holidays",
  "Community Groups",
  "Black History",
] as const;
export type TopicTitle = (typeof Topics)[number];

export type TopicInfo = {
  title: TopicTitle | string;
  basePath?: string;
  slug?: string;
};

export const DEFAULT_TOPICS: TopicInfo[] = [
  {
    title: "Drawing",
    slug: "drawing",
  },
  {
    title: "Gaming",
    slug: "gaming",
  },
  {
    title: "Dance",
    slug: "dance",
  },
  {
    title: "Art",
    slug: "arts-and-crafts",
  },
  {
    title: "Escape Rooms",
    slug: "escape-rooms",
  },
  {
    title: "Singing",
    slug: "singing",
  },
];

type ConditionalTopicInfo = TopicInfo & {
  // format: MM/DD
  includeOn: string;
  // format: MM/DD
  excludeAfter: string;
};

const dateFormat: string = "MM/DD";

const conditionalTopics: ConditionalTopicInfo[] = [
  {
    title: "Valentine's Day",
    slug: "valentines-day",
    includeOn: "02/01",
    excludeAfter: "02/14",
  },
  {
    title: "Black History",
    slug: "black-history-courses",
    includeOn: "02/01",
    excludeAfter: "03/01",
  },
  {
    title: "St. Patrick's Day",
    slug: "st-patricks-day",
    includeOn: "03/01",
    excludeAfter: "03/17",
  },
  {
    title: "Women's History",
    slug: "womens-history",
    includeOn: "03/01",
    excludeAfter: "03/31",
  },
  {
    title: "Spring Break",
    slug: "spring-break",
    includeOn: "03/11",
    excludeAfter: "04/25",
  },
  {
    title: "Mother's Day",
    slug: "mothers-day",
    includeOn: "04/19",
    excludeAfter: dayjs()
      .month(4)
      .startOf("month")
      .startOf("isoWeek")
      .day(0)
      .add(2, "w")
      .add(2, "d")
      .format("MM/DD"),
  },
  {
    title: "Father's Day",
    slug: "fathers-day",
    includeOn: "6/09",
    excludeAfter: "6/20",
  },
  {
    title: "Halloween",
    slug: "halloween",
    includeOn: "10/01",
    excludeAfter: "10/31",
  },
  {
    title: "Holidays",
    slug: "holidays",
    includeOn: "11/01",
    excludeAfter: "12/31",
  },
];

export function currentConditionalTopics(): TopicInfo[] {
  const dayjsObj = dayjs();
  return conditionalTopics
    .filter((t: ConditionalTopicInfo) => {
      const includeDate = dayjs(t.includeOn, dateFormat);
      const excludeDate = dayjs(t.excludeAfter, dateFormat);
      return (
        dayjsObj.isSameOrAfter(includeDate) &&
        dayjsObj.isSameOrBefore(excludeDate)
      );
    })
    .sort((a: ConditionalTopicInfo, b: ConditionalTopicInfo) =>
      a.title > b.title ? 1 : -1,
    )
    .map(t => {
      return {
        title: t.title,
        basePath: t.basePath,
        slug: t.slug,
      };
    });
}
